import axios from "axios";
import { Notification, MessageBox, Message, Loading } from "element-ui";
import store from "@/store";
import myStore from "@/store/store";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { tansParams } from "@/utils/tool";
import cache from "@/plugins/cache";
import { showLoading, hideLoading } from "@/utils/loading";
import router from "../router";
import {uploadLogs} from '@/api/user'

// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";


// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.NODE_ENV === "production" ? process.env.VUE_APP_BASE_API : '/api',
  // 超时
  timeout: 40000,
  retry: 3, //设置全局重试请求次数（最多重试几次请求）
  retryDelay: 1000, //设置全局请求间隔
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (!config.noShowLoading) {
      showLoading() // 显示加载中
    }
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (getToken() && !isToken) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // local_20250221
    // ZNCWUUID1721368273741
    config.headers["sn"] = myStore.state.deviceNo || 'dev3'
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?" + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (
      !isRepeatSubmit &&
      (config.method === "post" || config.method === "put")
    ) {
      const requestObj = {
        url: config.url,
        data:
          typeof config.data === "object"
            ? JSON.stringify(config.data)
            : config.data,
        time: new Date().getTime(),
      };
      const sessionObj = cache.session.getJSON("sessionObj");
      if (
        sessionObj === undefined ||
        sessionObj === null ||
        sessionObj === ""
      ) {
        cache.session.setJSON("sessionObj", requestObj);
      } else {
        const s_url = sessionObj.url; // 请求地址
        const s_data = sessionObj.data; // 请求数据
        const s_time = sessionObj.time; // 请求时间
        const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
        if (
          s_data === requestObj.data &&
          requestObj.time - s_time < interval &&
          s_url === requestObj.url
        ) {
          const message = "数据正在处理，请勿重复提交";
          console.warn(`[${s_url}]: ` + message);
          return Promise.reject(new Error(message));
        } else {
          cache.session.setJSON("sessionObj", requestObj);
        }
      }
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);
function containsField(str, field) {
  const regex = new RegExp(field, 'i'); // 'i' 表示不区分大小写
  return regex.test(str);
}
// 响应拦截器
service.interceptors.response.use(
  (res) => {
    hideLoading(); // 关闭加载
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    // 日志接口直接返回
    if(containsField(res.config.url, '/logs/save')){
        return res
    }
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res;
    }
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true;

        uploadLogs({
          content: '接口401，强制退出',
          errorCode: -2,
          module: '退出登录'
        }).catch(e => {})

        store.dispatch("LogOut").then(() => {
          location.href = "/login";
        });
      }
      return Promise.reject("登录状态已过期，请重新登录");
    } else if (code === 500) {
      Message({
        message: msg,
        type: "error",
      });
      return Promise.reject(new Error(msg));
    } else if (code !== 200) {
      Notification.error({
        title: msg,
      });
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    hideLoading();
    console.log("err" + error);
    // 日志接口直接返回
    if(containsField(error.config.url, '/logs/save')){
      return Promise.reject(error);
    }
    var config = error.config
    config.baseURL= ''
    let { message } = error;
    if (message == "Network Error") {
      message = "网络异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    //---------接口重试----------------------------------------------------
    if (!config || !config.retry) {
      return Promise.reject(error)
    }
    // __retryCount用来记录当前是第几次发送请求
    config.__retryCount = config.__retryCount || 0
    // 如果当前发送的请求大于等于设置好的请求次数时，弹窗提示，可手动刷新
    console.log('==============',config,'============')
    if (config.__retryCount >= config.retry) {
      return MessageBox.confirm(message, '警告', {
        confirmButtonText: '刷新重试', 
        type: 'error',
        center: true,
        confirmButtonClass: 'message-box__button',
        showCancelButton: false
      }).then(() => {
        return service(error.config)
        // let routerName = localStorage.getItem('routerName')
        // if(routerName){
        //   router.push({name: 'netErrPage'})
        // }else {
        //   window.location.reload();
        // }
      }).catch(() => {
        Message({
          type: 'info',
          message: '已取消'
        });
      });
    }
    Message.error("请求失败,重试中", config.retry)
    // 记录请求次数+1
    config.__retryCount += 1
    // 设置请求间隔 在发送下一次请求之前停留一段时间，时间为上方设置好的请求间隔时间
    var backoff = new Promise(function (resolve) {
        setTimeout(function () {
            resolve()
        }, config.retryDelay || 1)
    })
    // 再次发送请求
    return backoff.then(function () {
        return service(config)
    })
  }
);


export default service;

